import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  registerGenericApiErrorRedirect,
  unregisterGenericApiErrorRedirect,
  GENERIC_API_ERROR_PATH,
} from '../../utils/apiErrorRedirect.utils';

/**
 * Binds programmatic navigation for global API error redirects (axios interceptors run outside React).
 */
export const ApiErrorNavigationRegistrar: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    registerGenericApiErrorRedirect(() => {
      navigate(GENERIC_API_ERROR_PATH, { replace: true });
    });
    return () => unregisterGenericApiErrorRedirect();
  }, [navigate]);

  return null;
};
